/**
 * 母亲节抽奖模块：按奖品权重生成 20 条假中奖播报，并垂直循环滚动
 */
(function () {

  const FIRST = [
    'Emma', 'James', 'Olivia', 'Liam', 'Ava', 'Noah', 'Sophia', 'Mason', 'Mia', 'Ethan', 'Luna', 'Lucas', 'Lily', 'Oliver', 'Zoe', 'Logan', 'Ella', 'Aiden', 'Nora', 'Caleb', 'Hannah', 'Ryan', 'Ivy', 'Jack', 'Chloe', 'Leo', 'Violet', 'Evan', 'Grace', 'Wyatt', 'Elena', 'Luke', 'Ruby', 'Adam', 'Stella', 'Hugo', 'Iris', 'Jude', 'Skye', 'Kai', 'Bella', 'Nate', 'Clara', 'Owen', 'Daisy', 'Max', 'Freya', 'Toby', 'Gwen', 'Sam', 'Hope', 'Ben', 'Dan', 'Rose', 'Ian', 'Anna', 'Tom', 'May', 'Ray', 'Jon', 'Kay', 'Eva', 'Zoe', 'Alex', 'John', 'Lena', 'Paul', 'Sara', 'Rita', 'Gina', 'Duke', 'Mark', 'Cole', 'Nina', 'Jade', 'Reid', 'Tara', 'Maya', 'Will', 'Finn', 'Erin', 'Neil', 'Ruth', 'Joan', 'Cara', 'Troy', 'Beth', 'Drew', 'Erik', 'Gale', 'Hank', 'Ivan', 'Jake', 'Kara', 'Leah', 'Mike', 'Nate', 'Opal', 'Pete', 'Ross', 'Sean', 'Tess', 'Vera', 'Wade', 'Xena', 'Yale', 'Zara',
  ];

  const DOMAINS = [
    'gmail.com',
    'yahoo.com',
    'outlook.com',
    'hotmail.com',
    'icloud.com',
    'protonmail.com',
  ];

  function pickPrizeName(prizes) {
    if (!prizes || !prizes.length) {
      return 'a prize';
    }
    var totalW = 0;
    for (var i = 0; i < prizes.length; i += 1) {
      var w = Number(prizes[i].w) || 0;
      if (w > 0) {
        totalW += w;
      }
    }
    if (totalW <= 0) {
      return prizes[Math.floor(Math.random() * prizes.length)].n;
    }
    var r = Math.random() * totalW;
    for (var j = 0; j < prizes.length; j += 1) {
      var wj = Number(prizes[j].w) || 0;
      if (wj <= 0) {
        continue;
      }
      r -= wj;
      if (r <= 0) {
        return prizes[j].n;
      }
    }
    return prizes[prizes.length - 1].n;
  }

  function makeMaskedName() {
    var a = FIRST[Math.floor(Math.random() * FIRST.length)];
    var lastI = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 26)];
    return (a[0] || 'U') + '*** ' + lastI + '.';
  }

  function makeMaskedEmail() {
    var c = 'abcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random() * 26)] + '***';
    var d = DOMAINS[Math.floor(Math.random() * DOMAINS.length)];
    return c + '@' + d;
  }

  function makeLine(prizes, wonText) {
    var verb = (wonText && String(wonText).trim()) || 'won';
    var p = pickPrizeName(prizes);
    return makeMaskedName() + ' (' + makeMaskedEmail() + ') ' + verb + ' ' + p;
  }

  function buildTicker(winner, data) {
    var prizes = data.prizes;
    if (!prizes || !prizes.length) {
      winner.hidden = true;
      return;
    }

    var wonText = data.wonText;
    var n = 20;
    var lines = [];
    for (var i = 0; i < n; i += 1) {
      lines.push(makeLine(prizes, wonText));
    }
    var rows = lines.concat(lines);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var p = document.createElement('p');
      p.className = 'ug-mday-lottery__winner-text';
      p.textContent = lines[0];
      winner.appendChild(p);
      return;
    }

    var rail = document.createElement('div');
    rail.className = 'ug-mday-lottery__winner-rail';
    rail.setAttribute('aria-label', 'Simulated recent winners');

    var ul = document.createElement('ul');
    ul.className = 'ug-mday-lottery__winner-track ug-ml-anim';
    for (var j = 0; j < rows.length; j += 1) {
      var li = document.createElement('li');
      li.className = 'ug-mday-lottery__winner-item';
      li.setAttribute('role', 'listitem');
      li.textContent = rows[j];
      ul.appendChild(li);
    }
    rail.appendChild(ul);
    winner.appendChild(rail);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function initAll() {
    var winners = document.querySelectorAll('[data-ug-ml-winner]:not([data-ug-ml-winner-inited])');
    for (var w = 0; w < winners.length; w += 1) {
      var winner = winners[w];
      winner.setAttribute('data-ug-ml-winner-inited', '');

      var section = winner.closest('section.ug-mday-lottery') || winner.closest('section');
      if (!section) {
        continue;
      }
      var cfgEl = section.querySelector('script.ug-ml-winner-cfg');
      if (!cfgEl) {
        continue;
      }
      var raw = (cfgEl.textContent || '').trim();
      if (!raw) {
        continue;
      }
      var data;
      try {
        data = JSON.parse(raw);
      } catch (e) {
        continue;
      }
      var sec = Number(data.durationSec);
      if (!sec || sec < 0) {
        sec = 50;
      }
      winner.style.setProperty('--ug-ml-tick', sec + 's');
      while (winner.firstChild) {
        winner.removeChild(winner.firstChild);
      }
      buildTicker(winner, data);
    }
  });
})();
